module.exports = __webpack_public_path__ + "static/media/star9.9f477e9f.svg";